export default process.env.REACT_APP_API_URL;

export const { REACT_APP_HEADER } = process.env;
